/** Extracts the video id from the usual YouTube URL formats (watch?v=, youtu.be/, embed/). */
export function parseYouTubeId(url: string): string {
  const match = /(youtu\.be\/|youtube\.com\/(watch\?(.*&)?v=|(embed|v)\/))([^\\?&"'>]+)/.exec(url);
  return match ? match[5] : '';
}
